module.exports = "/static/js/d9b49dfc95f08a68d0c235729238ed44.png";